import { render, staticRenderFns } from "./LikeTags.vue?vue&type=template&id=6602860a&scoped=true&"
import script from "./LikeTags.vue?vue&type=script&lang=js&"
export * from "./LikeTags.vue?vue&type=script&lang=js&"
import style0 from "./LikeTags.vue?vue&type=style&index=0&id=6602860a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6602860a",
  null
  
)

export default component.exports